<div class="loading-dots" >
    <div class="loading-dots-dot"></div>
    <div class="loading-dots-dot"></div>
    <div class="loading-dots-dot"></div>
</div>